import { ReactNode } from "react";
import { Link, useLocation } from "wouter";
import { PageHeader } from "@/components/page-header";
import { cn } from "@/lib/utils";

interface Tab {
  label: string;
  href: string;
  testId: string;
}

const TABS: Tab[] = [
  { label: "Dashboard", href: "/compliance/dashboard", testId: "tab-compliance-dashboard" },
  { label: "Complaints", href: "/compliance/complaints", testId: "tab-compliance-complaints" },
  { label: "Calendar", href: "/compliance/calendar", testId: "tab-compliance-calendar" },
  { label: "ACC Checklist", href: "/compliance/acc", testId: "tab-compliance-acc" },
  // Sprint 22 - Operations Hub
  { label: "Credit Representatives", href: "/compliance/credit-reps", testId: "tab-compliance-credit-reps" },
  { label: "Insurance Policies", href: "/compliance/insurance", testId: "tab-compliance-insurance" },
  { label: "Document Library", href: "/compliance/documents", testId: "tab-compliance-documents" },
  { label: "Memberships", href: "/compliance/memberships", testId: "tab-compliance-memberships" },
  { label: "Data Security", href: "/compliance/security-audits", testId: "tab-compliance-security-audits" },
];

interface ComplianceLayoutProps {
  children: ReactNode;
}

export function ComplianceLayout({ children }: ComplianceLayoutProps) {
  const [location] = useLocation();

  return (
    <div className="flex h-screen w-full flex-col">
      <PageHeader
        title="Compliance Manager"
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "Compliance Manager" },
        ]}
      />

      <div className="flex-1 overflow-auto bg-muted/20">
        {/* Sub-navigation tabs */}
        <div className="border-b bg-background px-4">
          <nav className="flex gap-0" role="tablist">
            {TABS.map((tab) => {
              const isActive =
                location === tab.href ||
                location.startsWith(tab.href + "/") ||
                location.startsWith(tab.href + "?");
              return (
                <Link key={tab.href} href={tab.href}>
                  <button
                    role="tab"
                    data-testid={tab.testId}
                    data-active={isActive ? "true" : "false"}
                    className={cn(
                      "px-4 py-3 text-sm font-medium border-b-2 transition-colors",
                      isActive
                        ? "border-primary text-primary"
                        : "border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground"
                    )}
                  >
                    {tab.label}
                  </button>
                </Link>
              );
            })}
          </nav>
        </div>

        {/* Page content */}
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
}
